import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Dossier criminel pour alcool au volant: possible de voyager aux États-Unis?"
            description="Vous avez été reconnu coupable d’alcool au volant? Découvrez quelles sont les conséquences d’un casier judiciaire sur vos possibilités de voyager à l’étranger, notamment aux États-Unis!"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour alcool au volant">
            <p>
                Au Canada, lorsqu’on est reconnu coupable de conduite avec les
                facultés affaiblies par l’alcool, plusieurs conséquences
                découlent de cette condamnation.{' '}
            </p>
            <p>
                <strong>
                    L’une des principales est l’obtention d’un dossier criminel.
                </strong>{' '}
                En effet, l’infraction liée à l’alcool au volant sera inscrite
                au casier judiciaire du contrevenant.
            </p>
            <ul>
                <li>
                    Cela soulève une question importante :{' '}
                    <strong>
                        avoir un dossier criminel peut-il empêcher de voyager,
                        notamment aux États-Unis?{' '}
                    </strong>
                </li>
            </ul>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Voyager aux États-Unis avec un casier judiciaire!"
                    alt=""
                />
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>
                                Dans cet article, nous expliquons comment une
                                condamnation pour alcool au volant peut affecter
                                les déplacements internationaux, notamment vers
                                les États-Unis!
                            </strong>
                        </p>
                    </td>
                </tr>
            </table>
            <h2>
                Est-ce qu’une condamnation pour alcool au volant affecte les
                possibilités de voyager à l’étranger?
            </h2>
            <p>
                <strong>
                    Voyager à l’étranger lorsqu’on a un casier judiciaire pour
                    conduite avec les facultés affaiblies par l’alcool peut
                    entraîner certaines complications.
                </strong>{' '}
                Une telle condamnation peut effectivement limiter les
                déplacements internationaux.
            </p>
            <p>
                Toutefois, les lois et politiques d’immigration varient
                considérablement d’un pays à l’autre, et chaque État demeure
                souverain quant aux conditions d’admission sur son territoire.
                Ainsi, une <strong>condamnation pour alcool au volant</strong>{' '}
                <strong>n’empêche pas systématiquement de voyager</strong>, mais
                elle peut devenir un obstacle selon la destination choisie.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            En effet,{' '}
                            <strong>chaque pays décide librement</strong> s’il
                            souhaite autoriser l’entrée d’une personne reconnue
                            coupable de cette infraction. Une telle condamnation
                            peut être tolérée par certains États, alors qu’elle
                            entraînera un refus d’entrée dans d’autres.
                        </p>
                    </td>
                </tr>
            </table>
            <h3>
                Peut-on voyager en Europe (espace Schengen) avec une
                condamnation pour alcool au volant?
            </h3>
            <ul>
                <li>
                    <strong>
                        Une condamnation pour alcool au volant n’empêche
                        normalement pas de voyager en Europe, dans l’espace
                        Schengen, pour des séjours touristiques de moins de 90
                        jours.
                    </strong>{' '}
                </li>
            </ul>
            <p>
                En effet, les détenteurs d’un passeport canadien n’ont pas
                besoin de visa pour ces courts séjours, et aucune vérification
                systématique du casier judiciaire n’est effectuée à l’arrivée.
                Ainsi, voyager dans l’espace Schengen pour une durée inférieure
                à trois mois, même avec un casier judiciaire lié à une
                infraction pour alcool au volant, ne pose généralement pas de
                problème.
            </p>
            <p>
                <strong>
                    L’espace Schengen regroupe les pays européens suivants :
                </strong>
            </p>
            <table>
                <tr>
                    <td>
                        <ul>
                            <li>Allemagne</li>
                            <li>Autriche</li>
                            <li>Belgique</li>
                            <li>Bulgarie</li>
                            <li>Croatie </li>
                            <li>Danemark</li>
                            <li>Espagne</li>
                            <li>Estonie</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>Finlande</li>
                            <li>France</li>
                            <li>Grèce</li>
                            <li>Hongrie</li>
                            <li>Islande </li>
                            <li>Italie</li>
                            <li>Lettonie</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>Liechtenstein</li>
                            <li>Lituanie</li>
                            <li>Luxembourg</li>
                            <li>Malte</li>
                            <li>Norvège</li>
                            <li>Pays-Bas</li>
                            <li>Pologne</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>Portugal </li>
                            <li>République tchèque </li>
                            <li>Roumanie</li>
                            <li>Slovaquie</li>
                            <li>Slovénie</li>
                            <li>Suède</li>
                            <li>Suisse</li>
                        </ul>
                    </td>
                </tr>
            </table>
            <p>
                Cependant, certaines exceptions existent. Pour des séjours plus
                longs, ou lorsque le voyage nécessite l’obtention d’un visa
                (pour des études, un emploi ou une résidence), les autorités
                compétentes peuvent demander un certificat de police. Dans ces
                situations, une condamnation pour alcool au volant pourrait
                avoir un impact négatif sur la demande.
            </p>
            <h4>Changement à venir: ETIAS!</h4>
            <p>
                <strong>
                    Toutefois, à compter de la mise en place complète du système
                    ETIAS (prévue en 2026), les voyageurs en provenance de pays
                    exemptés de visa, comme le Canada, devront obtenir une
                    autorisation de voyage électronique avant d’entrer dans
                    l’espace Schengen.
                </strong>{' '}
            </p>
            <p>
                La demande pour obtenir une autorisation ETIAS se fera en ligne
                et impliquera de répondre à plusieurs questions, notamment sur
                les antécédents judiciaires.
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Voyager en Europe avec une condamnation d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Alors, une condamnation pour conduite avec les facultés
                affaiblies par l’alcool pourrait influencer la décision des
                autorités européennes d’accorder ou non cette autorisation
                <strong> de voyage électronique</strong>. En effet, si
                l’infraction est jugée susceptible de représenter un risque pour
                la sécurité ou l’ordre public, l’accès à l’espace Schengen peut
                être refusé.
            </p>
            <p>
                Il est important de souligner qu’il est{' '}
                <strong>illégal de fournir de fausses informations</strong> sur
                le formulaire ETIAS. Mentir sur son casier judiciaire constitue
                une infraction sérieuse, qui peut non seulement entraîner un
                refus d’entrée, mais aussi compromettre tout voyage futur vers
                l’Europe. Il est donc{' '}
                <strong>
                    vivement déconseillé de dissimuler une condamnation
                </strong>
                , même si elle peut sembler mineure.
            </p>
            <h3>
                Qu’en est-il des voyages dans les pays du sud avec un dossier
                criminel lié à l’alcool au volant?
            </h3>
            <p>
                De nombreux voyageurs canadiens choisissent de passer leurs
                vacances dans le Sud, notamment dans les Caraïbes.
            </p>
            <p>
                En général, des pays comme Cuba, la Jamaïque, le Mexique, ou la
                République dominicaine ne requièrent pas de visa ni
                d’autorisation préalable pour les Canadiens pour un séjour de
                courte durée, et
                <strong>
                    {' '}
                    l’entrée avec une condamnation pour alcool au volant ne pose
                    alors habituellement pas de problème
                </strong>
                .
            </p>
            <p>
                D’ailleurs, tout comme dans l’espace Schengen, un casier
                judiciaire pour alcool au volant peut devenir un obstacle lors
                d’une demande de visa de travail, de résidence ou pour toute
                autre démarche d’immigration.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>
                                Une décision toujours discrétionnaire!
                            </strong>
                        </p>
                        <p>
                            Il faut garder à l’esprit que{' '}
                            <strong>
                                l’entrée dans un pays étranger n’est jamais un
                                droit
                            </strong>
                            , mais un privilège accordé par les autorités du
                            pays hôte.{' '}
                        </p>
                        <p>
                            Même si toutes les exigences semblent remplies, un
                            agent frontalier est en droit de poser des questions
                            sur les antécédents judiciaires d’un voyageur à son
                            arrivée et peut refuser l’admission s’il considère
                            que ce dernier représente un risque.
                        </p>
                        <p>
                            Ainsi, une condamnation pour alcool au volant
                            n’empêche pas nécessairement de voyager, mais elle
                            peut entraîner des refus d’entrée dans certains cas.
                        </p>
                    </td>
                </tr>
            </table>
            <h2>
                Est-il possible de voyager aux États-Unis avec une condamnation
                pour alcool au volant?
            </h2>
            <p>
                Les États-Unis font partie des destinations les plus fréquentées
                par les Canadiens, et la question d’une éventuelle interdiction
                d’entrée en raison d’une condamnation pour conduite avec les
                facultés affaiblies par l’alcool revient fréquemment.{' '}
            </p>
            <ul>
                <li>
                    La bonne nouvelle, c’est qu’en général,
                    <strong>
                        {' '}
                        une seule condamnation pour alcool au volant ne
                        constitue pas un motif automatique de refus d’entrée.
                    </strong>
                </li>
            </ul>
            <p>
                En effet, selon les directives des U.S. Customs and Border
                Protection, une condamnation pour conduite avec les facultés
                affaiblies par l’alcool n’est{' '}
                <strong>
                    pas considérée comme un crime impliquant une turpitude
                    morale
                </strong>
                , une catégorie d’infractions qui entraîne généralement une
                inadmissibilité d’entrée.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Voyager aux États-Unis avec une condamnation d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Toutefois, tout reste à la discrétion de l’agent frontalier. Il
                peut refuser l’entrée si plusieurs condamnations apparaissent
                dans le dossier ou si le comportement passé laisse croire à une
                consommation problématique d’alcool.
            </p>
            <p>
                Il est à noter que si le dossier criminel contient une
                condamnation pour alcool au volant en plus d’autres infractions
                criminelles, la situation peut devenir plus compliquée. Dans ce
                cas, une demande de dérogation (Waiver) devra être soumise aux
                autorités américaines pour obtenir l’autorisation d’entrer sur
                le territoire.
            </p>
            <h2>
                Une demande de pardon est-elle recommandée pour voyager à
                l’étranger?
            </h2>
            <p>
                <Link to="https://avocatsalcoolauvolant.ca/obtenir-pardon-alcool-volant-quebec/">
                    <strong>Obtenir un pardon</strong>
                </Link>
                , également appelé suspension du casier judiciaire, peut
                grandement faciliter les déplacements à l’étranger d’une
                personne ayant été reconnue coupable de conduite avec facultés
                affaiblies par l’alcool. Cette démarche, prévue par la{' '}
                <em>Loi sur le casier judiciaire</em>, vise à limiter les
                conséquences sociales et professionnelles liées à la possession
                d’un casier judiciaire.
            </p>
            <h3>Qu’est-ce qu’un pardon et à quoi sert-il?</h3>
            <p>
                <strong>
                    Un pardon au Canada est une mesure qui rend une condamnation
                    criminelle confidentielle dans les bases de données
                    officielles.{' '}
                </strong>
            </p>
            <ul>
                <li>
                    <strong>
                        Un pardon ne fait pas disparaître une condamnation du
                        système judiciaire canadien, mais il la rend
                        inaccessible lors d’une vérification standard du casier
                        judiciaire.
                    </strong>
                </li>
            </ul>
            <p>
                Il est à noter que l’infraction demeure inscrite dans les bases
                de données de la Gendarmerie royale du Canada, mais elle est
                déplacée vers une section sécurisée, non accessible lors d’une
                vérification ordinaire du casier judiciaire. Cela permet à la
                personne de ne plus être pénalisée dans sa vie quotidienne,
                notamment lorsqu’elle cherche un emploi, un logement ou désire
                faire du bénévolat.
            </p>
            <p>
                <strong>
                    Dans le cadre des voyages à l’étranger, le pardon peut aussi
                    représenter un atout
                </strong>
                .{' '}
            </p>
            <p>
                Il rend les antécédents criminels normalement inaccessibles lors
                des demandes de visa ou des contrôles frontaliers, ce qui peut
                faciliter l’entrée dans plusieurs pays.{' '}
            </p>
            <p>
                D’ailleurs, lorsqu’il est obligatoire de fournir un certificat
                de police dans le cadre d’une demande d’immigration, la
                condamnation pour infraction liée à l’alcool au volant
                n’apparaît pas sur le document.
            </p>
            <h3>
                <strong>
                    <strong>
                        Quand et comment faire une demande de pardon?
                    </strong>
                </strong>
            </h3>
            <p>
                Avant de déposer une demande de pardon de casier judiciaire, il
                est essentiel de respecter les délais d’attente prévus par la
                loi. Ces délais varient selon la nature de la condamnation :
            </p>
            <ul>
                <li>
                    10 ans pour une infraction jugée par voie de mise en
                    accusation.
                </li>
                <li>5 ans pour une infraction jugée par voie sommaire.</li>
            </ul>
            <p>
                Ces délais commencent à courir à partir de la fin de la peine,
                ce qui inclut le paiement d’amendes, la période de probation ou
                la peine d’emprisonnement.{' '}
            </p>
            <p>
                Il est pertinent de mentionner que la plupart des condamnations
                pour conduite avec les facultés affaiblies par l’alcool sont
                jugées par procédure sommaire. Dans ce cas, la personne
                souhaitant obtenir un pardon doit attendre cinq ans après avoir
                terminé sa peine avant de pouvoir en faire la demande.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Comment faire une demande de pardon au Canada?"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Pour faire une demande de pardon, plusieurs documents sont
                    nécessaires, tels que :
                </strong>
            </p>
            <ul>
                <li>
                    <strong>Casier judiciaire</strong> : Le casier judiciaire
                    doit être obtenu auprès de la Gendarmerie royale du Canada.
                    Cette procédure requiert généralement la prise d’empreintes
                    digitales, ce qui implique de se rendre dans un poste de
                    police.
                </li>
                <li>
                    <strong>Preuve de condamnation</strong> : Il est nécessaire
                    de fournir une copie officielle du jugement ou tout autre
                    document émis par la cour qui atteste de la condamnation.
                </li>
                <li>
                    <strong>Informations sur la condamnation</strong> : La
                    demande doit inclure des détails précis sur la condamnation,
                    notamment les peines prononcées (amendes, emprisonnement)
                    ainsi que la date à laquelle le jugement a été rendu.
                </li>
                <li>
                    <strong>Vérifications de police locale</strong> : En
                    fonction des endroits où la personne a résidé au cours des
                    cinq dernières années, elle doit fournir des vérifications
                    des dossiers de police locaux pour chacun de ces endroits.
                </li>
                <li>
                    <strong>Pièce d’identité valide</strong> : Une photocopie
                    d’une pièce d’identité officielle, telle qu’un permis de
                    conduire, un passeport ou une autre pièce reconnue, doit
                    être jointe au dossier.
                </li>
            </ul>
            <h2>Un pardon est-il utile pour voyager aux États-Unis?</h2>
            <p>
                Les États-Unis représentent un cas particulier.{' '}
                <strong>
                    Leurs autorités américaines ne reconnaissent pas les effets
                    juridiques du pardon canadien
                </strong>
                . En vertu de la loi américaine sur l'immigration, les agents
                frontaliers doivent examiner les condamnations passées, même si
                elles ont fait l’objet d’une suspension du casier au Canada.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>
                                <em>IMPORTANT:</em>
                            </strong>
                        </p>
                        <p>
                            Si une condamnation pour conduite avec facultés
                            affaiblies par l’alcool a déjà été découverte par
                            les autorités américaines avant l’obtention d’un
                            pardon, elle restera inscrite dans leurs bases de
                            données et pourra être utilisée pour refuser
                            l’entrée aux États-Unis, même si le casier est
                            désormais scellé au Canada!
                        </p>
                    </td>
                </tr>
            </table>
            <ul>
                <li>
                    <strong>
                        Toutefois, si les États-Unis n’ont jamais eu
                        connaissance du casier judiciaire avant le pardon, ils
                        ne pourront plus y accéder, car l’information est
                        supprimée des bases accessibles à l’international.
                    </strong>
                </li>
            </ul>
            <p>
                Bref, dans certaines situations, un pardon ne suffit pas, et une
                dérogation spéciale (Waiver of Inadmissibility) est nécessaire
                pour entrer légalement aux États-Unis.
            </p>
            <h4>Faut-il quand même faire une demande de pardon?</h4>
            <p>
                <strong>
                    Oui, même si le pardon ne garantit pas l’admission aux
                    États-Unis, il demeure une démarche fortement recommandée!
                </strong>
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>
                                <em>IMPORTANT:</em>
                            </strong>
                        </p>
                        <p>
                            Il est important de noter que si une personne n’a
                            pas voyagé aux États-Unis entre sa condamnation pour
                            alcool au volant et l’obtention de son pardon, il
                            est fortement recommandé de présenter une demande de
                            pardon, puisque la condamnation ne figurera pas dans
                            les bases de données américaines.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Par ailleurs, le pardon canadien est généralement reconnu dans
                la plupart des pays, rendant la condamnation de conduite avec
                les facultés affaiblies par l’alcool inaccessible lors des
                vérifications et facilitant ainsi les démarches pour voyager à
                l’étranger.
            </p>
            <p>
                Cependant, pour les voyages aux États-Unis, il est recommandé de
                faire preuve de prudence et, au besoin, de consulter un avocat
                afin de déterminer si une demande de Waiver est nécessaire dans
                votre situation!
            </p>
            <h2>
                Qu’est-ce qu’un Waiver américain et est-il nécessaire d’en
                demander un pour une condamnation d’alcool au volant?
            </h2>
            <p>
                Le Waiver of Inadmissibility est une dérogation spéciale
                délivrée par les autorités américaines, qui permet à une
                personne jugée inadmissible, notamment en raison de son casier
                judiciaire, d’entrer temporairement aux États-Unis. Ce document
                n’efface pas le passé criminel, mais autorise, à titre
                exceptionnel, l’entrée sur le territoire pour une durée
                déterminée.
            </p>
            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Qu’est-ce qu’un Waiver américain?"
                    alt=""
                />
            </p>
            <p>
                En principe, une seule condamnation pour conduite avec facultés
                affaiblies par l’alcool ne rend pas automatiquement une personne
                inadmissible, car cette infraction n’est pas considérée par la
                loi américaine comme un crime de turpitude morale.
            </p>
            <p>
                Toutefois, si la personne a plusieurs condamnations ou si
                d’autres infractions figurent à son dossier, les chances de se
                voir refuser l’entrée aux États-Unis augmentent fortement. Dans
                ce cas, obtenir un Waiver<em> </em>devient pratiquement
                indispensable.
            </p>
            <p>
                Le processus de demande comprend plusieurs étapes, telles que :
            </p>
            <ol>
                <li>La prise d’empreintes digitales </li>
                <li>Le remplissage du formulaire I-192 </li>
                <li>
                    La rédaction d’une lettre d’explication détaillée et la
                    présentation de documents démontrant la réhabilitation{' '}
                </li>
                <li>Le paiement de frais d’environ 930 $ USD </li>
                <li>
                    Le traitement du dossier prend généralement entre six mois
                    et un an
                </li>
            </ol>
            <p>
                Il faut noter que le Waiver est temporaire, généralement valide
                de un à cinq ans selon les cas, et peut être renouvelé.
            </p>
            <p>
                Ainsi, dans les cas où une demande de pardon ne suffit pas,
                notamment lorsque l’information sur la condamnation figure déjà
                dans les bases de données américaines ou en présence de
                plusieurs infractions criminelles, il est fortement recommandé
                d’envisager une demande de Waiver.
            </p>
            <h2>
                Vous désirez obtenir un pardon ou un Waiver américain? Consultez
                un avocat spécialisé en droit criminel!
            </h2>
            <p>
                Bien que vous puissiez soumettre une demande de pardon ou de
                Waiver américain vous-même, il est fortement recommandé de
                travailler avec un avocat spécialisé en droit criminel!{' '}
            </p>
            <p>
                <strong>
                    Un avocat pourra vous conseiller sur la pertinence, selon
                    votre situation, d’obtenir un pardon ou un Waiver.
                </strong>
            </p>
            <p>
                Faire appel à un avocat spécialisé en droit criminel pour vous
                accompagner tout au long de ce processus peut grandement
                faciliter les démarches et augmenter vos chances de succès!
            </p>
            <p>
                <Img
                    fluid={data.img5.childImageSharp.fluid}
                    title="Avocat pour demande de pardon pour voyager!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Grâce à notre formulaire simple et gratuit, vous pourrez
                    rapidement entrer en contact avec un avocat spécialisé en
                    droit criminel pour vous aider dans votre demande de pardon
                    ou de Waiver américain!
                </strong>
            </p>
            <p>
                <strong>
                    Une fois votre demande soumise, nous vous mettrons en
                    relation avec un avocat près de chez vous, sans aucune
                    obligation de votre part!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "voyager-etats-unis-alcool-volant/voyager-etats-unis-casier-judiciaire.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "voyager-etats-unis-alcool-volant/voyager-europe-condamnation-alcool-volan.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "voyager-etats-unis-alcool-volant/voyager-usa-condamnation-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "voyager-etats-unis-alcool-volant/comment-faire-demande-pardon-canada.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "voyager-etats-unis-alcool-volant/waiver-american-condamnation-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img5: file(
            relativePath: {
                eq: "voyager-etats-unis-alcool-volant/avocat-demande-pardon-voyager.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
